
/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
const REGEX = {
  EMAIL_PATTERN: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w{2,4}([-.]\w+)*$/,
  PASSWORD_PATTERN:
    /(?=[A-Za-z0-9!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~])(?=.{8,16}).*$/, // Passwords must be Include at least 1 lowercase letter, 1 capital letter, 1 number,  1 special character => !@#$%^&*
  NAME_PATTERN: /^[ A-Za-z_@./#&+-]*$/,
};

const urls = {
  prodUrl: 'https://users.coversure.in',
  testUrl: 'https://users.coversure.click',
  payuTest: 'https://test.payu.in/_payment',
  payuProd: 'https://secure.payu.in/_payment',
};

export {
  REGEX,
  urls,
};
